// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","170":"e216087f","202":"3c50fd7d","274":"8ca5e8a0","827":"bf9860f7"}[chunkId] + ".chunk.js";
};